import { Item } from "../../lib/interfaces";
import parse from 'html-react-parser';

interface ItemsProps {
    data: Array<Item>;
}

export default function Items({ data }: ItemsProps) {
    return <div className="panel">
        {data.map(item => <>
            <h2>{item.name}</h2>
            <p>{parse(item.description)}</p>
        </>)}
    </div>;
}